import React from 'react'
import { Button } from '@mui/material'
import { useAppState } from 'Context/AppContext/AppContext'
import { IntakeFlowStep } from '../../constants'
import { sendStepTransitionEvent } from '../../utils'
import {
  Container,
  StyledTextField,
  ButtonContainer,
} from './OtherFocusAreas.styled'

type Props = {
  onNextStep: (nextStep: IntakeFlowStep) => void
  onBackStep: () => void
  onSetOtherFocusAreas: (challenge: string) => void
  otherFocusAreas: string
}

export const OtherFocusAreas = ({
  onNextStep,
  onBackStep,
  onSetOtherFocusAreas,
  otherFocusAreas,
}: Props) => {
  const { nonprofitOrgConfig, userConfig } = useAppState()

  const handleNext = () => {
    sendStepTransitionEvent({
      currentStep: IntakeFlowStep.OTHER_FOCUS_AREAS,
      nextStep: IntakeFlowStep.LOADING_IMPACT_PLAN,
      userId: userConfig.id,
      nonprofitOrgId: nonprofitOrgConfig.orgId,
      funderOrgId: nonprofitOrgConfig.funderOrgId,
      userEmail: userConfig.email,
      userPrimaryFunction: undefined,
      userJourneyLength: 0,
      userRole: undefined,
    })
    onNextStep(IntakeFlowStep.LOADING_IMPACT_PLAN)
  }

  return (
    <Container>
      <StyledTextField
        fullWidth
        multiline
        minRows={4}
        value={otherFocusAreas}
        placeholder='My organization struggles with consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua'
        onChange={(e) => onSetOtherFocusAreas(e.target.value)}
      />
      <ButtonContainer>
        <Button variant='text' onClick={onBackStep}>
          Back
        </Button>
        <Button variant='contained' onClick={handleNext}>
          Next
        </Button>
      </ButtonContainer>
    </Container>
  )
}
